<template>
    <div class="kb-category">
        <div class="panel h1-panel">
            <div class="panel-heading">
                <h1><router-link to="/kb">Knowledge Base</router-link></h1>
            </div>
            <div class="panel-body">
                <h2>Category</h2>
            </div>
        </div>

        <section class="panel results-panel">
            <div class="panel-body">
                <div v-if="!isLoading">
                    <div class="category-heading">
                        <img
                            :src="category.imageUrl"
                            v-if="category.imageUrl">
                        <img
                            src="../assets/img/ttto-thumbnail.jpg"
                            v-else>
                        <h2>{{ formatCategoryArticlesTitle(category, articles) }}</h2>
                    </div>

                    <div v-if="articles.length > 0 || canAuthor">
                        <ol>
                            <li v-for="article in articles">
                                <kb-block-link
                                    class="article-block"
                                    :to="getArticleLocation(article)">
                                    <div class="article-wrapper">
                                        <img
                                            :src="getCoverImageUrl(article)"
                                            v-if="getCoverImageUrl(article)">
                                        <img
                                            src="../assets/img/ttto-thumbnail.jpg"
                                            v-else>
                                        <div>
                                            <h3>{{ article.title }}</h3>
                                            <p>
                                                <BlockEllipsis>
                                                    <div v-html="article.overview"></div>
                                                </BlockEllipsis>
                                            </p>
                                        </div>
                                    </div>
                                </kb-block-link>
                            </li>

                            <li v-if="canAuthor">
                                <kb-block-link
                                    title="Create an article"
                                    :to="getArticleEditorLocation(category)">
                                </kb-block-link>
                            </li>
                        </ol>
                    </div>
                </div>

                <div class="loading-msg" v-else>
                    Loading...
                </div>
            </div>
        </section>

        <kb-feedback></kb-feedback>
    </div>
</template>

<script>
    import moment from 'moment';
    import toastr from 'toastr';

    import KbService     from '../services/knowledge-base';
    import BlockEllipsis from './reusable/block-ellipsis';
    import KbBlockLink   from './widgets/KbBlockLink';
    import KbFeedback    from './widgets/KbFeedback';

    export default {
        components: {
            BlockEllipsis,
            KbBlockLink,
            KbFeedback,
        },

        data() {
            return {
                articles: [],
                isLoading: true,
            };
        },

        async mounted() {
            this.isLoading = true;

            // The category name is given in the url, but in order to retrieve
            // the category articles, we'll need the category ID.
            await this.$store.dispatch('ensureKbCategories');
            if (!this.category) {
                toastr.error('Category not found.');
                return;
            }

            // Now we can actually load the articles.
            const articles = await KbService.getArticles({
                category: this.category.id,
            });
            this.articles = articles.sort((a, b) => {
                return a.title.localeCompare(b.title);
            });
            this.isLoading = false;
        },

        methods: {
            getArticleLocation(article) {
                return {
                    path: `/kb-article/${article.id}`
                };
            },

            getArticleEditorLocation(category) {
                return {
                    path: `/kb-article-editor?category=${category.id}`
                };
            },

            formatCategoryArticlesTitle(category, articles) {
                let base;
                switch (category.label) {
                    case 'General':
                    case 'Technical':
                        base = `${category.label} Articles`;
                        break;
                    default:
                        base = `Articles about ${category.label}`;
                        break;
                }

                if (articles.length > 0) {
                    return base;
                } else {
                    return `No ${base}`;
                }
            },

            getCoverImageUrl(article) {
                if (article.coverImageUrl) {
                    return article.coverImageUrl;
                }
                return this.category.imageUrl;
            },
        },

        computed: {
            category() {
                const name = this.$route.params.categoryName;
                const cats = this.$store.getters.kbCategories;
                return cats.find(c => c.name === name);
            },

            canAuthor() {
                const userRoles = JSON.parse(localStorage.roles);
                const allowedRoles = [
                    'OnlineDirector',
                    'Supervisor',
                    'Faculty',
                ];
                return userRoles.some(r => allowedRoles.includes(r));
            },
        },
    }
</script>

<style lang="scss" scoped>
    .h1-panel {
        display: flex;

        .panel-heading,
        .panel-body {
            height: auto;
            width: auto;
            display: flex;
            align-items: center;
        }

        h1 {
            margin: 10px 0;

            a {
                color: inherit;
                text-decoration: none;
                &:hover {
                    color: #33ccff;
                }
            }
        }

        h2 {
            margin: 10px 15px;
            font-size: 18px;
        }
    }

    .results-panel {
        h2 {
            margin: 0 0 40px 0;
        }

        ol {
            list-style-type: none;
            margin: -20px 0 40px 0;
            padding: 0 20px;
            position: relative;
            z-index: 1;
        }

        li {
            margin-bottom: 20px;
        }

        .loading-msg {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100px;
            width: 100%;
            font-style: italic;
        }

        .category-heading {
            padding: 40px 20px;
            position: relative;
            z-index: 0;

            img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: -2;
                object-fit: cover;
                mask-image: linear-gradient(
                    to bottom,
                    rgba(0, 0, 0, 0.6),
                    rgba(0, 0, 0, 0)
                );
            }
        }

        .article-block {
            position: relative;
            z-index: 0;
            height: 128px;
        }

        .article-wrapper {
            height: 100%;
            padding: 15px 20px 15px 148px;

            img {
                position: absolute;
                top: 0;
                left: 0;
                width: 128px;
                height: 128px;
                object-fit: cover;
                z-index: -1;
            }

            h3 {
                margin: 10px 0;
                color: #33ccff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// KbCategory.vue?6655dcdc